import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import { SectionContainer } from '../landings/styles'

const CooperationBreadcrumbs = () => {
  return (
    <SectionContainer as='div'>
      <Breadcrumbs
        breadcrumbs={[
          { label: 'Strona główna', path: PATHS.home },
          { label: 'Współpraca', path: PATHS.cooperation }
        ]}
      />
    </SectionContainer>
  )
}

export default CooperationBreadcrumbs
